/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Util} from "../Utilities.js";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import ElementStatus from "./ElementStatus.jsx";
import {Backups} from "../Objects/Backups.jsx";

class BackupManagement extends Component {
    constructor() {
        super();
        this.state = {
            allBackups: []
        }
    }


    async fetchData() {
        let allBackups = await Database.table("Backups", "app").getData()
        this.setState({allBackups: allBackups.recordset})
    }

    componentDidMount() {
        this.fetchData()
    }


    async editImage(domain) {

        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2"}>
                <OutputList>
                    <OutputListItem titel={"indexKey"}>
                        <span>{domain.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupName"}>
                        <span>{domain.backupName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupPath"}>
                        <span>{domain.backupPath}</span>
                    </OutputListItem>
                    <OutputListItem titel={"elementId"}>
                        <span>{domain.elementId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"elementId"}>
                        <span>{domain.elementId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"backupSize"}>
                        <span>{domain.backupSize}</span>
                    </OutputListItem>
                    {/*<OutputListItem titel={""}>*/}
                    {/*    <ButtonComponent*/}
                    {/*        text={"Remove backup"}*/}
                    {/*        onClick={async () => {*/}
                    {/*            await Backups(domain.indexKey).remove()*/}
                    {/*            await this.fetchData()*/}
                    {/*            close()*/}
                    {/*        }}></ButtonComponent>*/}


                    {/*</OutputListItem>*/}

                </OutputList>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Backup", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allBackups} = this.state

        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Backup"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Backups"} elementId={row.indexKey}/>

                            {row?.URL !== undefined && (<>
                                <IconButtonComponent text={`Open`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         let url = "/a/" + row.URL.replace(/^\//g, '')
                                                         // open the page
                                                         UI.page().navigate({
                                                             pathname: url,
                                                         })
                                                     }}/>
                            </>)}

                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allBackups.map(item => ({
                        ...item,
                        Name: <>{item.backupName} </>

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                     <ButtonComponent iconName={"IoAdd"}
                                                                      onClick={() => {
                                                                          //AppActions.layout.newLayout()
                                                                      }}
                                                                      text={`Neue  `}/>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editImage(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default BackupManagement;